import {useAuth} from "@bounce/shared/contexts";
import {usePartnerUi} from "~/contexts/PartnerUiContext";
import {useConsumerUser} from "~/contexts";

export const useNewDesignEnabled = (): boolean => {
  const {whiteLabelEnabled} = usePartnerUi();
  const {loggedIn} = useAuth();
  const {isNoLogin, userContext} = useConsumerUser();

  if (whiteLabelEnabled) {
    return false;
  }

  if (!loggedIn && !isNoLogin) {
    return true;
  }

  return userContext?.new_design_eligible ?? false;
};
